import React from 'react'

import {Box} from '@vio/atlas/helpers/Box'
import {Image} from '@vio/atlas/Image'
import {StarRating} from '@vio/atlas/StarRating'
import {ImageProvider} from '@vio/core/src/staticContent/types/ImageProvider'

import {BaseTaxationAndPriceMessage} from '../../search/BaseTaxationAndPriceMessage'
import {Location} from '../../search/Location'
import {ReviewRating} from '../../search/ReviewRating'
import {
  Container,
  HotelName,
  ImageContainer,
  ReviewRatingWrapper
} from './styles'

interface PropsType {
  showTotalPrices?: boolean
  imageProvider: ImageProvider
  hotelImageUrl: string
  starRating?: number
  hotelName: string
  hotelId: string
  place?: string
  reviewRaiting?: number
  totalRatingCount?: number
  includeTaxes: boolean
}

export const HotelInfoCard = ({
  showTotalPrices = true,
  imageProvider,
  hotelImageUrl,
  starRating,
  hotelName,
  place,
  hotelId,
  reviewRaiting,
  totalRatingCount,
  includeTaxes
}: PropsType) => {
  return (
    <Container>
      <Box display="flex">
        <ImageContainer>
          <Image url={hotelImageUrl} imageProvider={imageProvider} />
        </ImageContainer>

        <Box display="flex" flexDirection="column" flexGrow="1">
          <Box padding="s300" paddingTop="s400">
            {starRating && <StarRating size="xs" rating={starRating} />}
            <HotelName data-id="HotelName">{hotelName}</HotelName>
            {place && <Location place={place} hotelId={hotelId} />}
            <ReviewRatingWrapper>
              <ReviewRating
                rating={reviewRaiting}
                totalRatingCount={totalRatingCount}
                hotelId={hotelId}
              />
            </ReviewRatingWrapper>
            <Box
              display="flex"
              flexDirection="column"
              paddingTop="s500"
              justifyContent="flex-end"
              alignItems="flex-end"
            >
              <BaseTaxationAndPriceMessage
                includeTaxes={includeTaxes || showTotalPrices}
                showTotalPrices={showTotalPrices}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Container>
  )
}
